import createSvgIcon from "./utils/create_icon"

const InfoOutline = createSvgIcon(<><g fill="currentColor"><path d="M11 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm0 3a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0z" /><path clipRule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zm-2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0z" fillRule="evenodd" /></g></>, "InfoOutline")
export default InfoOutline
